class Signalement {
    constructor() {
        document.addEventListener(
            "alpine:init",
            () => {
                Alpine.data("signalement", () => ({
                    message: null,

                    reportSuccess: false,
                    reportLoading: false,
                    reportError: false,

                    report(eventId, dateId, element) {
                        if (
                            element.ariaDisabled === "true" ||
                            this.sendSuccess
                        ) {
                            return;
                        }

                        this.reportLoading = true;
                        window.useHttpApi
                            .post(
                                `/v1/report/event`,
                                {
                                    event: eventId,
                                    date: dateId,
                                    comment: this.message,
                                },
                                { extra: { dialog: true } },
                            )
                            .then(() => {
                                this.reportSuccess = true;
                                setTimeout(() => {
                                    this.closeDialog();
                                }, 1000);
                            })
                            .catch(() => {
                                this.reportError = true;
                            })
                            .finally(() => {
                                this.reportLoading = false;
                            });
                    },

                    openDialogError() {
                        this.message = null;
                        this.reportError = false;
                        this.reportLoading = false;
                        this.reportSuccess = false;

                        const dialog = document.querySelector(
                            `[x-ref='dialogSignalement']`,
                        );
                        if (dialog && !dialog.open) {
                            dialog.showModal();
                        }
                    },

                    closeDialog() {
                        const dialog = document.querySelector(
                            `[x-ref='dialogSignalement']`,
                        );
                        if (dialog?.open) {
                            dialog.close();
                        }
                    },
                }));
            },
            { once: true },
        );
    }
}

new Signalement();
